import RcDomainObject from "@/domain/common/RcDomainObject.js";
import CheckList from "@/domain/model/checklist/CheckList.js";
import Company from "@/domain/model/company/Company.js";
import CheckListSnapshot from "./CheckListSnapshot.js";

/**
 * A frozen copy of a checklist, written by the server the first time an inspection is
 * answered against a given state of it. Inspections point at the version they used,
 * so editing the checklist afterwards changes no past inspection.
 */
export default class CheckListVersion extends RcDomainObject {

  static MODEL_NAME = 'CheckListVersion';

  static Fields = {
    CHECKLIST: CheckList.MODEL_NAME,
    COMPANY: Company.MODEL_NAME,
    NUMBER: "number",
    SNAPSHOT: "snapshot",
  }

  constructor(domain, data) {
    super(domain, data, CheckListVersion.MODEL_NAME);
  }

  fields() {
    return CheckListVersion.Fields;
  }

  find() {
    var result = this.domain.checklists().versions().findById(this.id());
    if (result.id() !== this.id()) {
      result = this;
    }
    return result;
  }

  // The reference may arrive as a pointer object or as the bare id; RcObject reads both.
  checklist() {
    return new CheckList(this.domain, this.get(CheckListVersion.Fields.CHECKLIST));
  }

  company() {
    return new Company(this.domain, this.get(CheckListVersion.Fields.COMPANY));
  }

  number() {
    return this.getInt(CheckListVersion.Fields.NUMBER);
  }

  hasSnapshot() {
    return this.has(CheckListVersion.Fields.SNAPSHOT);
  }

  snapshotText() {
    return this.getString(CheckListVersion.Fields.SNAPSHOT);
  }

  /** The parsed copy, or null when it is missing, unreadable or in a newer layout. */
  snapshot() {
    if (!this.hasSnapshot()) {
      return null;
    }
    return CheckListSnapshot.parse(this.domain, this.snapshotText());
  }

  copy() {
    var data = this._copy();
    return new CheckListVersion(this.domain, data);
  }
}
